import { Navigate, useLocation } from 'react-router';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';

interface Props {
    lang: MultiLang;
}

const getRedirectUrl = (pathname: string): string => {
    const matches = pathname.match(/^\/modules\/mediawiki\/(?:index\.php\/)?([^/]*)$/);
    if (matches === null) {
        return '';
    }
    return `/mediawiki/${matches[1] || ''}`;
};

const MediaWikiXoopsPathRedirect = (props: Props) => {
    const { lang } = props;
    const location = useLocation();
    const url = getRedirectUrl(location.pathname);
    if (url === '') {
        return <PageNotFound lang={lang} />;
    }
    return <Navigate to={url} replace />;
};

export default MediaWikiXoopsPathRedirect;
